/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { useState } from "react";
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import "./fonts.css"
import "./layout.css"

import Header from "./AppShell/Header"
import Nav from "./AppShell/Nav"
import Underlay from "./AppShell/Underlay"


const Layout = (props) => {

  const [menuIsActive, setMenuIsActive] = useState(false);
  const toggleMenuActive = () => setMenuIsActive(prev => !prev);
  const removeMenuActive = () => setMenuIsActive(false);

  const { children, /*location*/ } = props;
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
          allSitePage {
            edges {
              node {
                id
                path
                context {
                  slug
                }
              }
            }
          }
        }
      `}
      render={data => (
        <>

            <Header handler={toggleMenuActive} state={menuIsActive ? 'active' : ''} />

            <div id="ezoic-pub-ad-placeholder-102"> </div>

            <div>

              <main>{children}</main>

              <div id="ezoic-pub-ad-placeholder-144"> </div>

              <footer className="pb-[120px] md:pb-5">
                <p>
                © {new Date().getFullYear()} {data.site.siteMetadata.title} | Illustrations by <a rel="noopener noreferrer" target="_blank" href="https://dlanid.com/">Denis Davydov</a> | <a href="mailto:hi@messivsronaldo.app">Contact</a> | <a href="/privacy-policy/">Privacy Policy</a>
                </p>
                <p><a rel="noreferrer" target="_blank" href="https://www.topscorers.club/">Top Scorers Club</a> | <a rel="noreferrer" target="_blank" href="https://non-gamstop.uk/">Casinos Not on Gamstop</a> | <a rel="noreferrer" target="_blank" href="https://grykasyno.biz/">Kasyno Online</a> | <a rel="noreferrer" target="_blank" href="https://aviator-slot.in/minimum-deposit/">Aviator Game Minimum Deposit</a> | <a rel="noreferrer" target="_blank" href="https://www.bdggame.io/">BDG Game</a> | <a rel="noreferrer" target="_blank" href="https://tirangagameapp.org/">Tiranga Game</a></p>
              </footer>

            </div>

            <Nav state={menuIsActive ? 'active' : ''} type="nav--slideout" />

            <Underlay handler={removeMenuActive} state={menuIsActive ? 'active' : ''} />

          </>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
